export default class gdprCompliance {
	/**
	 * @param {Object} options - User options
	 */
	constructor(options) {
		window.addEventListener('DOMContentLoaded', () => {
			this.init();
		});

		window.addEventListener('NAVIGATE_IN', () => {
			this.init();
		});

		window.addEventListener('infiniteScrollAppended', () => {
			this.init();
		});
	}

	init() {
		Yacc.configure({
			culture: 'it',
			cookiePageUrl: '/privacy-policy/',
		});
	}
}